import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Countries } from '@merchant-portal/mp-models'
import { Dock } from '../../../components/common'
import { getText } from '../../../internal/TextLabels'
import { ChatHistory } from './ChatHistory'
import { ChatEdit } from './ChatEdit'
import { ChatRequestForm } from './ChatRequestForm'
import cssStyles from '../chat.module.scss'
import { ChatOpeningHours } from './ChatOpeningHours'
import styles from './ChatOpeningHours.module.scss'

export const ChatRequestEditor = ({
  defaultChoice,
  requestDropDownText,
  title,
  history,
  requestLabel,
  buttonText,
  requestChoices,
  country,
  ...props
}) => {
  const isRequestTypeValid = type => {
    return type !== requestDropDownText
  }

  const [requestType, setRequestType] = useState(defaultChoice)
  const [requestTypeValid, setRequestTypeValid] = useState(
    isRequestTypeValid(defaultChoice),
  )
  const [message, setMessage] = useState(props.message)
  const [isClosed, setIsClosed] = useState(false)

  const onSetRequestType = type => {
    setRequestType(type)
    setRequestTypeValid(isRequestTypeValid(type))
  }

  const onRequestChat = msg => {
    const request = {
      type: requestType,
      msg: { text: msg, fromMe: true },
    }
    props.onSend(request)
  }

  return (
    <Dock
      title={title}
      closeText={getText('default.close')}
      onBack={props.onClose}
      onMinimize={() => props.onMinimize(requestType, message)}
      dockClass={cssStyles.dock}
      onBeforeCloseChat={props.onBeforeCloseChat}
    >
      <div>
        <ChatHistory history={history} />
        <ChatRequestForm
          label={requestLabel}
          defaultValue={requestType}
          dropDownText={requestDropDownText}
          choices={requestChoices}
          onChange={onSetRequestType}
          country={country}
          setIsClosed={setIsClosed}
        />
        {!isClosed ? (
          <ChatEdit
            buttonText={buttonText}
            onSend={onRequestChat}
            onChange={setMessage}
            currentText={message}
            requestTypeValid={requestTypeValid}
          />
        ) : (
          <>
            <br />
            <div className={styles.chatLineClosedTitle}>
              <strong>{getText('chat.info.closed.line')}</strong>
            </div>
            <ChatOpeningHours countryCode={country} />
          </>
        )}
      </div>
    </Dock>
  )
}

ChatRequestEditor.propTypes = {
  title: PropTypes.string.isRequired,
  history: PropTypes.array.isRequired,
  requestLabel: PropTypes.string.isRequired,
  requestDropDownText: PropTypes.string.isRequired,
  requestChoices: PropTypes.array.isRequired,
  defaultChoice: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onSend: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
  country: PropTypes.oneOf(Object.values(Countries)).isRequired,
  message: PropTypes.string,
}

ChatRequestEditor.defaultProps = {
  message: '',
}
